import { render, staticRenderFns } from "./PermissionActionDelete.vue?vue&type=template&id=31aebfd9&"
import script from "./PermissionActionDelete.vue?vue&type=script&lang=ts&"
export * from "./PermissionActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports